var _path, _path2, _path3, _g, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWProfile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_14972_61684",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 4H4V28H28V4Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_14972_61684)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27 16C27 22.0751 22.0751 27 16 27C9.92487 27 5 22.0751 5 16C5 9.92487 9.92487 5 16 5C22.0751 5 27 9.92487 27 16Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_14972_61684",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 16,
    width: 16,
    height: 9
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8571 24.6428C23.8571 20.3033 20.3395 16.7856 16 16.7856C11.6605 16.7856 8.14285 20.3033 8.14285 24.6428",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_14972_61684)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.4286 24.6429C25.4286 19.4355 21.2074 15.2144 16 15.2144V18.3572C19.4716 18.3572 22.2857 21.1713 22.2857 24.6429H25.4286ZM16 15.2144C10.7926 15.2144 6.57143 19.4355 6.57143 24.6429H9.71428C9.71428 21.1713 12.5284 18.3572 16 18.3572V15.2144Z",
    fill: "white"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9286 12.0714C19.9286 14.2411 18.1697 16 16 16C13.8303 16 12.0714 14.2411 12.0714 12.0714C12.0714 9.9017 13.8303 8.14282 16 8.14282C18.1697 8.14282 19.9286 9.9017 19.9286 12.0714Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWProfile);
export default __webpack_public_path__ + "static/media/W_profile.fe8f0c4d32b85b2bec0eeff7224b8c4f.svg";
export { ForwardRef as ReactComponent };